module.exports = __webpack_public_path__ + "media/images/icon/next-arrow-d1221a6566c5b01621dee943d0180e2e.svg";